import {ModuleWithProviders, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import {DialogComponent} from './dialog/dialog.component';
import { ShorterPipe } from './shorter.pipe';
import { OwlModule } from 'ngx-owl-carousel';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InternationalPhoneModule } from 'ng4-intl-phone';
import { FooterComponent } from './shared/footer/footer.component';
import { LotteryCounterComponent } from './lottery/lottery-counter/lottery-counter.component';
import {IconContainerComponent} from './shared/footer/icon-container/icon-container.component';
import {PaymentsComponent} from './shared/footer/payments/payments.component';
import { LocalizedDatePipe } from './localized-date.pipe';
import { TranslateService } from '@ngx-translate/core';
import { WhatWinnersSayComponent } from './shared/what-winners-say/what-winners-say.component';
import { CarouselComponent } from './carousel/carousel.component';
import { CounterLotteriesComponent } from './lotteries/counter-lotteries/counter-lotteries.component';
import { CarouselCounterComponent } from './carousel/carousel-counter/carousel-counter.component';
import { AddPaymentsComponent } from './add-payments/add-payments.component';
import {AddFundsModalComponent} from './shared/add-funds-modal/add-funds-modal.component';
import {DwSelectComponent} from './usability/dw-select/dw-select.component';
import {JackpotPipe} from './jackpot.pipe';
import { SearchHighlightPipe} from './shared/search/search-highlight.pipe';
import {JinniModalComponent} from './jinni-modal/jinni-modal.component';
import { ClickOutsideModule } from 'ng4-click-outside';
import { TimeZone } from './shared/time-zone.pipe';
import {ReplaceEuroPipe} from './replace-euro.pipe';
import {SafeHtmlPipe} from './safehtml.pipe';
import {
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatDatepickerModule,
    MatExpansionModule,
    MatInputModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
} from '@angular/material';

import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { BreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';
import {RouterModule} from '@angular/router';
import {LotteriesService} from './lotteries.service';
import {LoginService} from './shared/navigation/login.service';
import {SeoService} from './_services/seo.service';
import {CookiesComponent} from './shared/footer/cookies/cookies.component';
import {ScratchCheckoutComponent} from './scratch-checkout/scratch-checkout.component';
import {SafeUrlPipe} from './safe-url.pipe';
import { CookieService } from 'ngx-cookie-service';
import {SubscriptionsService} from './_services/subscriptions.service';
import {InstaRunComponent} from './insta-run/insta-run.component';
import {InstaGamesHomeComponent} from './insta-games/insta-games/insta-games-home/insta-games-home.component';
import {SparklingAnimationComponent} from './sparkling-animation/sparkling-animation.component';
import {ActionService} from './_services/action.service';
import {LogoutService} from './_services/logout.service';
import {JsontranslateService} from './_services/jsontranslate.service';
import {TextChangerPipe} from './shared/quick-pick/text-changer.pipe';
import { FancyDynamicBannerComponent } from './fancy-dynamic-banner/fancy-dynamic-banner.component';
import {CasinoWelcomeComponent} from './fancy-dynamic-banner/casino-welcome/casino-welcome.component';
import {CounterService} from './_services/counter.service';
import {JackpotConfigService} from './_services/jackpotConfig.service';
import {UniversalcounterComponent} from './shared/universalcounter/universalcounter.component';
import {IncomingdrawsService} from './_services/incomingdraws.service';
import {JinniErrorsMessagesComponent} from './jinni-errors-messages/jinni-errors-messages.component';
import {Angular4PaystackModule} from 'angular4-paystack';
import {NgxMaskModule} from 'ngx-mask';
import {JinniErrorModalComponent} from './jinni-error-modal/jinni-error-modal.component';
import {TooltipDialogComponent} from './tooltip-dialog/tooltip-dialog.component';
// import {GetPaymentMethodsService} from './shared/paymentMethod/get-payment-methods.service';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatDatepickerModule,
    OwlModule,
    MatInputModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
    MatSelectModule,
    Angular4PaystackModule,
    MatSlideToggleModule,
    MatExpansionModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    InternationalPhoneModule,
    ClickOutsideModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgxMaskModule
  ],
  declarations: [
      DwSelectComponent,
      DialogComponent,
      FooterComponent,
      PaymentsComponent,
      IconContainerComponent,
      CookiesComponent,
      LotteryCounterComponent,
      CounterLotteriesComponent,
      ShorterPipe,
      SearchHighlightPipe,
      BreadcrumbComponent,
      AddPaymentsComponent,
      LocalizedDatePipe,
      TimeZone,
      CarouselComponent,
      CarouselCounterComponent,
      WhatWinnersSayComponent,
      ScratchCheckoutComponent,
      SafeUrlPipe,
      TextChangerPipe,
      AddFundsModalComponent,
      InstaGamesHomeComponent,
      InstaRunComponent,
      SparklingAnimationComponent,
      FancyDynamicBannerComponent,
      CasinoWelcomeComponent,
      UniversalcounterComponent,
      JackpotPipe,
      JinniModalComponent,
      JinniErrorsMessagesComponent,
      ReplaceEuroPipe,
      SafeHtmlPipe,
      TooltipDialogComponent
  ],
  exports: [
      DwSelectComponent,
      DialogComponent,
      ShorterPipe,
      WhatWinnersSayComponent,
      LocalizedDatePipe,
      AddPaymentsComponent,
      LotteryCounterComponent,
      CounterLotteriesComponent,
      OwlModule,
      CarouselComponent,
      CarouselCounterComponent,
      FooterComponent,
      PaymentsComponent,
      IconContainerComponent,
      CookiesComponent,
      AddFundsModalComponent,
      BreadcrumbComponent,
      ShorterPipe,
      MatButtonModule,
      MatButtonToggleModule,
      MatCardModule,
      MatDatepickerModule,
      MatExpansionModule,
      MatInputModule,
      MatNativeDateModule,
      MatPaginatorModule,
      MatSelectModule,
      MatTableModule,
      MatSlideToggleModule,
      MatTabsModule,
      MatStepperModule,
      FormsModule,
      ReactiveFormsModule,
      InternationalPhoneModule,
      TranslateModule,
      ScratchCheckoutComponent,
      SafeUrlPipe,
      TimeZone,
      SearchHighlightPipe,
      TextChangerPipe,
    InstaGamesHomeComponent,
    InstaRunComponent,
    SparklingAnimationComponent,
      FancyDynamicBannerComponent,
      CasinoWelcomeComponent,
      UniversalcounterComponent,
      JackpotPipe,
      JinniModalComponent,
      JinniErrorsMessagesComponent,
      ReplaceEuroPipe,
      SafeHtmlPipe,
      TooltipDialogComponent
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [LoginService,
          LotteriesService,
          SeoService,
          CookieService,
          SubscriptionsService,
          ActionService,
          LogoutService,
          JsontranslateService,
          CounterService,
          JackpotConfigService,
          // GetPaymentMethodsService,
          IncomingdrawsService]
    };
  }
  constructor(private translate: TranslateService) {
      translate.addLangs(['en', 'de']);
      let browserLang = localStorage.getItem('pageLanguage');
      if (browserLang === null) {
          browserLang = translate.getBrowserLang();
          if (browserLang !== 'de') {
              browserLang = 'en';
          }
      }
      translate.use(browserLang);
  }
}
export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}
